/* eslint-disable indent */
const Urls = {
  DOMAIN_EMAPP:
    process.env.VUE_APP_ENV === 'test' || process.env.VUE_APP_ENV === 'staging'
      ? 'http://mobiletest.emoney.cn/emapp'
      : 'https://emapp.emoney.cn',
  DOMAIN_YKT:
    process.env.VUE_APP_ENV === 'test'
      ? 'http://mobilelan.emoney.cn/yktapi'
      : process.env.VUE_APP_ENV === 'staging'
      ? 'https://yktpre.emoney.cn/yktapi'
      : 'https://yktapi.emoney.cn',
  DOMAIN_STATIC:
    process.env.VUE_APP_ENV === 'test'
      ? 'http://mobilelan.emoney.cn/yktstatic'
      : process.env.VUE_APP_ENV === 'staging'
      ? 'https://yktpre.emoney.cn/yktstatic'
      : 'https://yktstatic.emoney.cn',
  DOMAIN_SECURE:
    process.env.VUE_APP_ENV === 'test'
      ? 'https://yktsecure.emoney.cn/'
      : process.env.VUE_APP_ENV === 'staging'
      ? 'https://yktsecure.emoney.cn/'
      : 'https://yktsecure.emoney.cn/'
}

export default Urls
